// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"4e08272d","296":"4e08272d"}[chunkId] + ".chunk.css";
};